import { Link } from "react-router-dom";
import { animeList } from "@/mocks/animeData";

const ranking = [...animeList].sort((a, b) => b.rating - a.rating).slice(0, 6);

const medal = ["bg-accent-500 text-foreground-950", "bg-background-300 text-foreground-700", "bg-primary-200 text-primary-800"];

export default function Ranking() {
  return (
    <section id="ranking" className="scroll-mt-20 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-widest text-primary-600">
              <i className="ri-medal-2-line"></i> Top Rated
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-900 md:text-4xl">高口碑榜单</h2>
            <p className="mt-3 text-sm leading-6 text-foreground-600">
              综合全网评分与口碑沉淀的 TOP 榜单，无论是补番还是安利，照着看准没错。
            </p>
            <Link
              to="/sousuo?sort=rating"
              className="mt-6 inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              查看完整榜单 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <ol className="space-y-3 lg:col-span-8">
            {ranking.map((a, i) => (
              <li
                key={a.id}
                className="flex items-center gap-4 rounded-lg bg-background-50 p-3 transition-transform hover:-translate-y-0.5"
              >
                <span
                  className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md font-heading text-base font-black ${
                    medal[i] ?? "text-foreground-500"
                  }`}
                >
                  {i + 1}
                </span>
                <img
                  src={a.image}
                  alt={`${a.title} 封面`}
                  className="h-16 w-11 shrink-0 rounded object-cover"
                  loading="lazy"
                />
                <div className="min-w-0 flex-1">
                  <h3 className="line-clamp-1 font-heading text-base font-bold text-foreground-900">{a.title}</h3>
                  <p className="mt-0.5 line-clamp-1 text-xs text-foreground-500">
                    {a.year} · {a.type} · {a.studio}
                  </p>
                </div>
                <span className="hidden items-center gap-1 whitespace-nowrap text-sm font-bold text-accent-600 sm:flex">
                  <i className="ri-star-fill"></i> {a.rating.toFixed(1)}
                </span>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}